import { useEffect, useRef } from 'react';

const useEffectDebounced = (
  effect: () => void | (() => void),
  deps: any[] | React.DependencyList,
  initialDelay: number = 50, // Delay inicial
  maxDelay: number = 500 // Tiempo máximo de debounce
) => {
  const isMounted = useRef(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const delayRef = useRef<number>(initialDelay); // Guarda el delay actual
  const lastExecutionTimeRef = useRef<number>(Date.now()); // Última vez que se ejecutó el efecto

  useEffect(() => {
    //const cleanup = effect();
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current); // Limpiar cualquier timeout anterior
    }

    if (isMounted.current) {
      const timeSinceLastExecution = Date.now() - lastExecutionTimeRef.current;

      // Si los cambios son muy rápidos, incrementamos el delay, hasta un máximo
      if (timeSinceLastExecution < delayRef.current) {
        delayRef.current = Math.min(delayRef.current * 2, maxDelay); // Dobla el delay hasta el máximo
      } else {
        delayRef.current = initialDelay; // Restablecer delay si no hay cambios rápidos
      }

      // Establece un nuevo timeout con el delay ajustado
      timeoutRef.current = setTimeout(() => {
        effect();
        lastExecutionTimeRef.current = Date.now(); // Actualizar última ejecución
      }, delayRef.current);
    } else {
      isMounted.current = true; // Primera vez que el componente está montado
    }

    return () => {
      //if (cleanup) cleanup();
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current); // Limpiar timeout al desmontar
      }
    };
  }, deps); // Dependencias que activarán el hook
};

export default useEffectDebounced;
